<template>
  <div class="card">
    <div class="row">
      <div class="col-md-12">
        <div style="font-size: 20px">
          <img
            v-if="obj.sinqroSellingPoint"
            :src="
              require('@/assets/img/' + getLogoSinqro(obj.sinqroSellingPoint))
            "
            class="sellingPointImg"
          />
          <strong class="tituloPedido" v-if="obj.tipoPedido === 'M'"
            >{{ $t("mesa") }} Nº {{ obj.numMesa }}</strong
          >
          <strong v-else class="tituloPedido"
            >{{ $t("pedido") }} Nº {{ obj.nPedido }}</strong
          >
          <small style="color: #a9a9a9"
            ><i class="fa fa-clock"></i> {{ obj.createdDate | timeago }}
          </small>
          <div
            v-if="
              obj.tiempoEstimado != '0' &&
                obj.tiempoEstimado != '' &&
                obj.envioprogramadodate == 0
            "
            :style="'float: right;'"
            :class="'btn-group'"
          >
            <div :class="'btn botonTotal'">
              <strong>
                {{ obj.total | currency }}
              </strong>
            </div>
            <div
              class="btn"
              v-if="obj.colorTiempo == 'rojo'"
              v-tooltip.top-center="'El tiempo estimado se ha superado'"
              style="background-color: #db3434; border-color: #db3434;"
            >
              <strong>
                {{ obj.tiempoEstimado.replace("utos", "") }}
                <i class="fas fa-exclamation-triangle"></i>
                <!--{{ obj.colorTiempo }} {{ obj.tiempoEstimado.replace('utos','')}}-->
              </strong>
            </div>
            <div
              class="btn"
              v-else-if="obj.colorTiempo == 'amarillo'"
              v-tooltip.top-center="
                'El tiempo estimado está cerca de superarse'
              "
              style="background-color: #e8d600; border-color: #e8d600;"
            >
              <strong>
                {{ obj.tiempoEstimado.replace("utos", "") }}
                <i class="fas fa-hourglass-end"></i>
              </strong>
            </div>
            <div
              class="btn"
              v-else
              style="background-color: grey; border-color: grey;"
              v-tooltip.top-center="'Tiempo estimado mostrado al cliente'"
            >
              <strong>
                {{ obj.tiempoEstimado.replace("utos", "") }}
                <i class="fas fa-hourglass-half"></i>
              </strong>
            </div>
          </div>
          <span v-else style="float: right" class="botonTotal"
            ><strong>{{ obj.total | currency }}</strong></span
          >
        </div>
        <template v-if="estadio">
          <!--<div class="col-md-12">-->
            <div class="mt-2" style="font-size:20px;">
              <strong class="tituloPedido" v-if="obj.nombreTpv != 0">{{obj.nombreTpv}}</strong><strong class="text-danger tituloPedido" style="font-weight:900" v-else>NO DESCARGADO EN TPV</strong>
            </div>
          <!--</div>-->
        </template>
        <br />

        <div class="row" style="margin-bottom: 0.5vw; margin-left:0">
          <div style="margin-right:1vw" v-if="obj.sinqroMarketIdCode">
            <p>
            <span
              class="alert alert-dark"
              style="font-size:1rem; color:#444"
            >
              <strong
                ><i class="fas fa-hashtag"></i>
                {{ obj.sinqroMarketIdCode }}</strong
              >
            </span>
            </p>
          </div>
          <div>
            <p>
              <span class="alert alert-warning" v-if="obj.cobrado">
                <strong
                  ><i class="fas fa-coins"></i>
                  {{ $t("cobradoMayusculas") }}</strong
                >
              </span>
            </p>
          </div>
        </div>

      </div>

      <div
        v-if="obj.envioprogramadodate"
        style="padding: 10px;background-color: #B2FFB2"
        class="col-md-12"
      >
        <strong>
          {{ $t("envioProgramadoPara") }}:
          {{ obj.envioprogramadodate | parseDateDelivery }}</strong
        ><br />
      </div>

      <div class="col-md-12">
        <strong>{{ $t("nombre") }}:</strong> {{ obj.nombreCliente }}
      </div>

      <template v-if="obj.tipoPedido !== 'M'">
        <div class="col-md-12" v-if="obj.phone">
          <strong>{{ $t("telefono") }}:</strong>
          <a :href="'tel:+34' + obj.phone">{{ obj.phone }}</a>
          <i
            class="fab fa-whatsapp-square"
            @click="sendWhatsapp(obj.phone)"
            style="color: green"
          ></i>
        </div>
        <div class="col-md-12" v-if="obj.codigoEmpleado">
          <strong>{{ $t("codigoEmpleado") }}:</strong> {{ obj.codigoEmpleado }}
        </div>
        <template v-if="obj.tipoPedido === 'D'">
          <div class="col-md-12">
            <strong>{{ $t("direccion") }}:</strong
            ><a
              target="_blank"
              :href="
                'https://www.google.es/maps/place/' +
                  '+' +
                  obj.direccionEnvio.replace('/', ' ') +
                  '+' +
                  obj.cp +
                  '+' +
                  obj.city
              "
            >
              {{ obj.direccionEnvio }} <i class="fas fa-map-marker-alt"></i
            ></a>
          </div>
          <div class="col-md-12">
            <strong>{{ $t("formasDePago") }}:</strong> {{ obj.nombreFormaPago }}
          </div>
          <div class="col-md-12">
            <strong>{{ $t("ciudad") }}:</strong> {{ obj.city }}
          </div>
          <div class="col-md-12">
            <strong>{{ $t("codigoPostal") }}:</strong> {{ obj.cp }}
          </div>
        </template>
        <div class="col-md-12"><strong>Id</strong> #{{ obj.hash }}</div>
      </template>
      <div
        v-if="obj.observacion"
        class="col-md-12"
        style="background-color: #FFFFB8;padding: 10px"
      >
        <strong> {{ obj.observacion }}</strong>
      </div>

      <!--BOTONES BOTTOM-->
      <div class="col-md-12 text-right">
        <button
          class="btn btnEliminar"
          v-if="obj.estado === 0"
          @click="$emit('openModalEliminarPedido', obj.id, 0, obj.idSinqro)"
        >
          <i class="far fa-trash-alt"></i>
          <strong> {{ $t("eliminarPedido") }} </strong>
        </button>
        <button
          class="btn btnEliminar"
          v-else-if="obj.estado === 1 && listConfig.cruzcampo"
          @click="$emit('openModalEliminarPedido', obj.id, 1, obj.idSinqro)"
        >
          <i class="far fa-trash-alt"></i>
          <strong> {{ $t("eliminarPedido") }} </strong>
        </button>

        <button
          class="btn btnConfirmados"
          v-if="obj.estado === 0"
          @click="preguntaActualizarPedido(obj, 1)"
          align="center"
        >
          <i class="fas fa-check-circle"></i>
          <strong> {{ $t("aceptarPedido") }}</strong>
        </button>
        <button
          v-else-if="obj.estado === 1"
          class="btn btnEnPreparacion"
          @click="preguntaActualizarPedido(obj, 2)"
          align="center"
        >
          <i class="fas fa-check-circle"></i
          ><strong> {{ $t("pasarAPreparacion") }}</strong>
        </button>
        <button
          v-else-if="obj.estado === 2"
          @click="preguntaActualizarPedido(obj, 3)"
          class="btn btnListos "
          align="center"
        >
          <i class="fas fa-check-circle"></i
          ><strong> {{ $t("pasarAPreparados") }}</strong>
        </button>
        <button
          v-else-if="obj.estado === 3"
          @click="preguntaActualizarPedido(obj, 4)"
          class="btn btnEnReparto"
          align="center"
        >
          <i class="fas fa-check-circle"></i
          ><strong> {{ $t("pasarAEnReparto") }}</strong>
        </button>
        <button
          v-else-if="obj.estado === 4"
          @click="preguntaActualizarPedido(obj, 5)"
          class="btn btnFinalizados"
          align="center"
        >
          <i class="fas fa-check-circle"></i
          ><strong> {{ $t("finalizarPedido") }}</strong>
        </button>
        <button
          v-else-if="obj.estado === 5"
          @click="preguntaActualizarPedido(obj, 6)"
          class="btn btnArchivados"
          align="center"
        >
          <i class="fas fa-check-circle"></i
          ><strong> {{ $t("archivarPedido") }}</strong>
        </button>

        <button
          class="btn btnDetalles"
          @click="
            (observacion = obj.observacion),
              $modal.show('detalles-pedido-modal' + obj.id)
          "
        >
          <i class="fas fa-info-circle"></i>
          <strong> {{ $t("detallesPedido") }} </strong>
        </button>

        <button
          class="btn btnRetroceder"
          v-if="obj.estado != 0 && obj.idHeader == 0 && obj.idSinqro == 0"
          @click="preguntaActualizarPedido(obj, (obj.estado - 1))"
        >
          <i class="fas fa-arrow-left"></i>
          <strong> {{ $t("retrocederEstado") }} </strong>
        </button>
      </div>
      <modal
        :name="'detalles-pedido-modal' + obj.id"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div>
          <div class="modal-header">
            <h4 style="margin: 0px">{{ $t("detallesDelPedido") }}</h4>
          </div>
          <div class="modal-body">
            <div v-if="obj.estado === 0">
              <label
                ><strong>{{ $t("nota") }}</strong></label
              >
              <input v-model="observacion" class="form-control" />
            </div>

            <div class="table-responsive" style="margin-top: 10px">
              <table class="table  table-striped">
                <thead>
                  <tr>
                    <th>{{ $t("producto") }}</th>
                    <th>{{ $t("precioUd") }}</th>
                    <th>{{ $t("cantidad") }}</th>
                    <th>{{ $t("total") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="det in obj.detalles">
                    <tr>
                      <td>
                        {{ det.nombreProducto + " " + det.namePrice }}
                        <template v-if="det.nombreCatego"
                          >({{ det.nombreCatego }})</template
                        >
                      </td>
                      <td align="right">{{ det.price | currency }}</td>
                      <td align="right">{{ det.units }}</td>
                      <td align="right">{{ det.amount | currency }}</td>
                    </tr>
                    <tr v-for="sub in det.subproducts">
                      <td align="left" style="padding-left: 15px">
                        > {{ sub.name }} -
                        <template v-if="sub.tipo === 'O'">{{
                          $t("opcional")
                        }}</template
                        ><template v-else-if="sub.tipo === 'E'">{{
                          $t("extra")
                        }}</template
                        ><template v-else>{{ $t("base") }}</template>
                        <template v-if="sub.free"
                          >({{ $t("gratis") }})</template
                        >
                      </td>
                      <td align="right">
                        {{ !sub.free ? sub.variacion : 0 | currency }}
                      </td>
                      <td align="right">{{ sub.cantidad }}</td>
                      <td align="right">
                        <template v-if="!sub.free">{{
                          (sub.cantidad * sub.variacion) | currency
                        }}</template>
                        <template v-else>{{ 0 | currency }}</template>
                      </td>
                    </tr>
                  </template>
                  <tr v-if="obj.importeGastosEnvio > 0">
                    <td colspan="3">{{ $t("gastosDeEnvio") }}</td>
                    <td align="right">
                      {{ obj.importeGastosEnvio | currency }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="3">
                      <strong>{{ $t("total") }}</strong>
                    </td>
                    <td align="right">{{ obj.total | currency }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-default"
              @click="
                (observacion = ''),
                  $modal.hide('detalles-pedido-modal' + obj.id)
              "
            >
              <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
            </button>
            <template v-if="obj.estado === 0">
              <button
                class="btn btn-primary"
                @click="
                  (obj.observacion = observacion),
                    $emit('agregarObservacion', obj.observacion, obj.id)
                "
              >
                <i class="fas fa-check"></i> {{ $t("guardar") }}
              </button>
              <button
                class="btn btn-success"
                @click="
                  (obj.observacion = observacion),
                    $emit('agregarObservacion', obj.observacion, obj.id),
                    preguntaActualizarPedido(obj, (obj.estado + 1))"
              >
                <i class="fas fa-check-circle"></i>
                {{ $t("guardarYAceptarPedido") }}
              </button>
            </template>
          </div>
        </div>
      </modal>
    </div>

    <!--$emit('getDatos')-->
  </div>
</template>

<script>
import swal from "sweetalert2";

export default {
  name: "itemPedido",
  props: ["obj", "estado", "tipoMesa", "tieneSinqro", "listConfig", "estadio"],

  computed: {
    totalDetalles() {
      var total = 0;

      this.obj.detalles.forEach(function(x) {
        total += x.amount;
      });

      return total;
    },
  },
  methods: {
    preguntaActualizarPedido(obj, estado) {
      swal({
        title: "¿Seguro que quiere modificar el estado del pedido?",
        text: "Esta acción puede afectar a su recepción en el tpv",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Aceptar",
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if(result.value) {
          obj.visto = false;
          this.$emit("confirmarPedido", obj.id, estado, obj.idSinqro);
        }
      });
    },
    getLogoSinqro(sinqroSellingPoint) {
      sinqroSellingPoint = sinqroSellingPoint.toLowerCase();
      var res = sinqroSellingPoint + "_gestion.svg";
      console.log(res);
      try {
        require("@/assets/img/" + res);
        return res;
      } catch (e) {
        return "sinqro.png";
      }
    },

    sendWhatsapp(phone) {
      //let url='El%20negocio%20*Baltazares*%20ha%20recibido%20el%20pedido%20con%20id%20%23*FDSNAFJD*.%0A%0ASi%20deseas%20aceptar%20el%20pedido%2C%20conteste%20este%20mensaje%20con%20un%20%27ok%27.%0A%0AEl%20total%20del%20pedido%20es%20de%20*10%E2%82%AC*';

      let url = "El%20pedido%20ha%20sido%20aceptado";

      var win = window.open(
        "https://web.whatsapp.com/send?phone=34" + phone + "&text=" + url,
        "_blank"
      );
      win.focus();
    },
  },

  data() {
    return {
      observacion: "",
    };
  },
};
</script>

<style scoped>
tbody tr:hover {
  background-color: rgba(0, 153, 130, 0.2);
  cursor: pointer;
}

td div {
  padding: 12px 8px;
  color: #333;
}

.buttonsSearch:hover {
  cursor: pointer;
  background-color: rgba(0, 153, 130, 0.1);
}

.card {
  padding: 20px;
  margin-bottom: 5px;
}

.input-group button {
  height: 40px;
}

.botonCobrado {
  font-weight: 400;
  padding: 8px 16px;
  margin-bottom: 5px;
  background-color: #4091e2;
  color: white;
  font-size: 14px;
  line-height: 1.42857143;
}

.botonTotal {
  border: 1px solid #28a745;
  color: #ffffff;
  background-color: #28a745;
  font-weight: 400;
  padding: 8px 16px;
  /* cursor: pointer; */
  margin-bottom: 5px;
  font-size: 14px;
  line-height: 1.42857143;
}

.botonTiempoRed {
  border: 1px solid #db3434;
  color: #ffffff;
  background-color: #db3434;
  font-weight: 400;
  padding: 8px 16px;
  /* cursor: pointer; */
  margin-bottom: 5px;
  font-size: 14px;
  line-height: 1.42857143;
}

.tituloPedido {
  color: #1E22AA;
  font-family: "Numier", "Helvetica Neue", Arial;
}

.list-leave-active {
  transition: 1s;
}

.list-leave-to {
  opacity: 0;
}

.btnConfirmados {
  margin-top: 20px;
  padding: 10px;
  background-color: #23923d;
  border-color: #23923d;
  color: white;
  float: right;
}

.btnEnPreparacion {
  background-color: #ff9510;
  border-color: #ff9510;
  margin-top: 20px;
  float: right;
}

.btnListos {
  background-color: #53385f;
  border-color: #53385f;
  margin-top: 20px;
  float: right;
}

.btnEnReparto {
  background-color: #11bfe3;
  border-color: #11bfe3;
  margin-top: 20px;
  float: right;
}

.btnFinalizados {
  background-color: #1E22AA;
  border-color: #1E22AA;
  margin-top: 20px;
  float: right;
}

.btnArchivados {
  background-color: #8896ab;
  border-color: #8896ab;
  margin-top: 20px;
  float: right;
}

.btnEliminar {
  background-color: #fa1825;
  border-color: #fa1825;
  margin-top: 20px;
  margin-right: 10px;
  padding: 10px;
}

.btnDetalles {
  background-color: #474747;
  border-color: #474747;
  float: right;
  margin-top: 20px;
  margin-right: 10px;
  padding: 10px;
}

.btnRetroceder {
  background-color: #556AFF;
  border-color: #556AFF;
  float: right;
  margin-top: 20px;
  margin-right: 10px;
  padding: 10px;
}

.sellingPointImg {
  height: 50px;
  width: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Widgets/Delivery/ItemPedido.vue